export default __webpack_public_path__ + "static/media/test404.6074ce12.png";